/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_COMPANY_REQUEST]: state => {
    state.loadingCompany = true;
    state.loadingCompanyFailed = false;
    state.loadingCompanySucceeded = false;
    state.loadingCompanyErrors = null;
  },

  [types.GET_COMPANY_FAILURE]: (state, error) => {
    state.loadingCompany = false;
    state.loadingCompanyFailed = true;
    state.loadingCompanyErrors = error;
  },

  [types.GET_COMPANY_SUCCESS]: (state, response) => {
    state.loadingCompany = false;
    state.loadingCompanySucceeded = true;
    state.company = response.data;
  },

  [types.UPDATE_COMPANY_REQUEST]: state => {
    state.updatingCompany = true;
    state.updatingCompanyFailed = false;
    state.updatingCompanySucceeded = false;
    state.updatingCompanyErrors = null;
  },

  [types.UPDATE_COMPANY_FAILURE]: (state, error) => {
    state.updatingCompany = false;
    state.updatingCompanyFailed = true;
    state.updatingCompanyErrors = error;
  },

  [types.UPDATE_COMPANY_SUCCESS]: (state, response) => {
    state.updatingCompany = false;
    state.updatingCompanySucceeded = true;
    state.company = response.data;
  },

  [types.GET_COMPANIES_REQUEST]: state => {
    state.loadingCompanies = true;
    state.laodingCompaniesSucceeded = false;
    state.loadingCompaniesFailed = false;
  },

  [types.GET_COMPANIES_FAILURE]: (state, error) => {
    state.loadingCompanies = false;
    state.loadingCompaniesSucceeded = false;
    state.loadingCompaniesFailed = true;
    state.loadingCompaniesErrors = error.error;
  },

  [types.GET_COMPANIES_SUCCESS]: (state, response) => {
    state.loadingCompanies = false;
    state.loadingCompaniesSucceeded = true;
    state.companies = response.data.results;
  },

  [types.GET_TIMEZONES_REQUEST]: state => {
    state.loadingTimezones = true;
    state.laodingTimezonesSucceeded = false;
    state.loadingTimezonesFailed = false;
  },

  [types.GET_TIMEZONES_FAILURE]: (state, error) => {
    state.loadingTimezones = false;
    state.loadingTimezonesSucceeded = false;
    state.loadingTimezonesFailed = true;
    state.loadingTimezonesErrors = error.error;
  },

  [types.GET_TIMEZONES_SUCCESS]: (state, response) => {
    state.loadingTimezones = false;
    state.loadingTimezonesSucceeded = true;
    state.timezones = response.data;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/company/mutations.js